import { render, staticRenderFns } from "./BudgetItem.vue?vue&type=template&id=9b8aab1c&"
import script from "./BudgetItem.vue?vue&type=script&lang=js&"
export * from "./BudgetItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports